import { useContent } from "@/cms/ContentContext";

// Preset → Tailwind class mappings
const SECTION_PY = {
  compacto: "py-14 md:py-20",
  normal: "py-28 md:py-40",
  espacoso: "py-36 md:py-56",
};

const TITLE_GAP = {
  colado: "mb-0",
  "muito-curto": "mb-2",
  curto: "mb-6",
  normal: "mb-12",
  espacoso: "mb-20 md:mb-28",
};

const OVERLINE_GAP = {
  colado: "mb-1",
  curto: "mb-4",
  normal: "mb-6",
  espacoso: "mb-10",
};

// Per-section fallbacks — mirror the current tuned layout
const DEFAULTS = {
  py: {
    sobre: "normal",
    servicos: "normal",
    portfolio: "normal",
    testemunhos: "normal",
    contacto: "normal",
  },
  titleGap: {
    sobre: "colado",
    servicos: "curto",
    portfolio: "curto",
    testemunhos: "normal",
    contacto: "normal",
  },
  overlineGap: {
    sobre: "curto",
    servicos: "curto",
    portfolio: "curto",
    testemunhos: "curto",
    contacto: "curto",
  },
};

/**
 * `useSpacing()` returns a set of class strings based on the current CMS
 * spacing config, per section. Falls back to per-section defaults.
 */
export const useSpacing = () => {
  const { content } = useContent();
  const sp = content?.spacing || {};

  const sectionPy = (section) =>
    SECTION_PY[sp.py?.[section] || DEFAULTS.py[section] || "normal"];

  const titleGap = (section) =>
    TITLE_GAP[sp.titleGap?.[section] || DEFAULTS.titleGap[section] || "normal"];

  const overlineGap = (section) =>
    OVERLINE_GAP[sp.overlineGap?.[section] || DEFAULTS.overlineGap[section] || "curto"];

  const showDividers = sp.dividers !== false;

  const divider = (extra = "") =>
    showDividers ? `border-t border-[#3A3524]/10 ${extra}` : extra;

  return { sectionPy, titleGap, overlineGap, showDividers, divider };
};

export const PRESET_OPTIONS = {
  py: [
    { value: "compacto", label: "Compacto" },
    { value: "normal", label: "Normal" },
    { value: "espacoso", label: "Espaçoso" },
  ],
  titleGap: [
    { value: "colado", label: "Colado (0)" },
    { value: "muito-curto", label: "Muito curto" },
    { value: "curto", label: "Curto" },
    { value: "normal", label: "Normal" },
    { value: "espacoso", label: "Espaçoso" },
  ],
  overlineGap: [
    { value: "colado", label: "Colado" },
    { value: "curto", label: "Curto" },
    { value: "normal", label: "Normal" },
    { value: "espacoso", label: "Espaçoso" },
  ],
};
